module.exports = __webpack_public_path__ + "static/media/cloud-computing.4748d1d2.jpg";